import { render } from "./AddMaintenanceSchedule.vue?vue&type=template&id=6d98b16b"
import script from "./AddMaintenanceSchedule.vue?vue&type=script&lang=js"
export * from "./AddMaintenanceSchedule.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script